var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row md-12"},[_c('SupportEndpoints')],1),_c('div',{staticClass:"row md-12"},[_c('ProductAgencySetting')],1),_c('div',{staticClass:"row md-12"},[_c('LogSearcher')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }